import { render, staticRenderFns } from "./comprehensive.vue?vue&type=template&id=1e6e9d5f&scoped=true"
import script from "./comprehensive.vue?vue&type=script&lang=js"
export * from "./comprehensive.vue?vue&type=script&lang=js"
import style0 from "./comprehensive.vue?vue&type=style&index=0&id=1e6e9d5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e6e9d5f",
  null
  
)

export default component.exports